// api/index.js
import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://ons6737sad.execute-api.us-east-1.amazonaws.com/dev',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add an interceptor to include idToken in headers
apiClient.interceptors.request.use(
  (config) => {
    const idToken = localStorage.getItem("idToken"); // Get idToken from localStorage
    if (idToken) {
      config.headers.Authorization = `Bearer ${idToken}`; // Set Authorization header
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;
